// extracted by mini-css-extract-plugin
export default {"headLine":"Headline_headLine__QZyxJ"};